import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

/**
 * Guards an admin-only route, nested inside RequireAuth. The sidebar never links here for
 * a non-admin (see navItems.ts `adminOnly`), so landing on this route as one is either a
 * stale bookmark or a deliberate URL probe — either way, the response is to revoke the
 * session server-side (POST /auth/logout) and send them to /login, not just redirect.
 */
export function RequireAdmin({ children }: { children: JSX.Element }) {
  const isAdmin = useAuthStore((s) => s.user?.role === 'admin');

  useEffect(() => {
    if (!isAdmin) {
      void useAuthStore.getState().logout();
    }
  }, [isAdmin]);

  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
